/*
    This file uses code from @react-three/drei.
    Original Copyright (c) 2020 react-spring
    Source: https://github.com/pmndrs/drei
    License: MIT (see Frontend/src/THIRD-PARTY-LICENSES/drei-MIT.txt)
*/

import { createContext } from 'react';

import type { Matrix4, Vector3 } from 'three';

export type Axis = 0 | 1 | 2; // 0 = x, 1 = y, 2 = z

export type Component = 'Arrow' | 'Slider' | 'Rotator' | 'Sphere';

export type SelectedControl = {
    component: Component;
    axis: Axis;
} | null;

export type OnDragStartProps = {
    component: Component;
    axis: Axis;
    origin: Vector3;
    directions: Vector3[];
};

export type PivotContext = {
    onDragStart: (props: OnDragStartProps) => void;
    onDrag: (mdW: Matrix4) => void;
    onDragEnd: () => void;

    translation: { current: [number, number, number] };
    translationLimits?: [[number, number] | undefined, [number, number] | undefined, [number, number] | undefined];
    rotationLimits?: [[number, number] | undefined, [number, number] | undefined, [number, number] | undefined];
    scaleLimits?: [[number, number] | undefined, [number, number] | undefined, [number, number] | undefined];
    axisColors: [string | number, string | number, string | number];
    hoveredColor: string | number | undefined;
    selectedColor: string | number | undefined;
    opacity: number;
    scale: number;
    lineWidth: number;
    fixed: boolean;
    depthTest: boolean;
    renderOrder: number;
    userData?: { [key: string]: unknown };
    annotations?: boolean;
    annotationsClass?: string;

    selectedControl: SelectedControl | null;
    setSelectedControl: (c: SelectedControl | null) => void;
};

export const context = /* @__PURE__ */ createContext<PivotContext>(null!);
